import React, { EffectCallback, useEffect, useState } from 'react';
import RouteBuilder from 'src/utils/routing/RouteBuilder';
import { useRouteBuilder } from 'src/utils/routing/RouteBuilderContext';
import ActionTray from 'src/containers/ActionTray/ActionTray';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import { GetFrequencyTypesAdminResponse } from 'src/types/apiResponse';
import FrequencyTypesAdminTable from 'src/components/FrequencyTypesAdminTable/FrequencyTypesAdminTable';
import AddItemLinkedButton from 'src/components/buttons/AddItemLinkedButton/AddItemLinkedButton';
import { getFromApi } from 'src/utils/getFromApi';
import { AxiosError } from 'axios';
import NoResultsFound from 'src/components/NoResultsFound/NoResultsFound';

function ManageFrequencyTypesPage(): FunctionComponentReturnType {
    const [data, setData] = useState<GetFrequencyTypesAdminResponse | null>(null);
    const [error, setError] = useState<AxiosError | null>(null);
    const routeBuilder: RouteBuilder = useRouteBuilder();
    const apiRoute: string = routeBuilder.api.getAllFrequenciesAdmin();

    const refreshData: EffectCallback = getFromApi(apiRoute, setData, setError);
    useEffect(refreshData, [apiRoute]);

    if (error) {
        throw error;
    }

    return (
        <div>
            <ActionTray>
                <AddItemLinkedButton linkTo={routeBuilder.client.toCreateFrequencyTypePage()}>
                    {'Add Frequency Type'}
                </AddItemLinkedButton>
            </ActionTray>
            {
                data && (
                    data.frequencyTypes.length ?
                        <FrequencyTypesAdminTable frequencyTypes={data.frequencyTypes} refreshData={refreshData}/> :
                        <NoResultsFound/>
                )
            }
        </div>
    );
}

export default ManageFrequencyTypesPage;
